import { byAttrVal, createCustomElement, DOMModel, registerEvent } from '@adobe/react-webcomponent'
import React, { ReactElement } from 'react'
import { QueryClientProvider } from 'react-query'
import { EmberEventFn } from 'src/types/emberEventFn'

import { UserOrganizationContextProvider } from '@modules-deprecated/app/organization'
import { CurrentUserContextProvider } from '@modules-deprecated/app/user'
import { InvoiceOverviewReconciliationSuggestionContent } from '@views/invoices/elements/InvoiceOverviewReconciliationSuggestionContent'

import { queryClient } from '../../config/queryClient'
import { ThemeProvider } from '../../contexts/themeProvider'

const MODULE_NAME = 'invoice-overview-reconciliation-suggestion-module'

class InvoiceOverviewReconciliationSuggestionWebComponent extends DOMModel {
  @byAttrVal organizationid: string
  @byAttrVal invoiceid: string
  @registerEvent('openPaymentModal') openPaymentModal: Function
}

type InvoiceOverviewReconciliationSuggestionProps = {
  organizationid: string
  invoiceid: string
  onOpenPaymentModal: EmberEventFn
}

export const InvoiceOverviewReconciliationSuggestion = ({
  invoiceid,
  organizationid,
  onOpenPaymentModal,
}: InvoiceOverviewReconciliationSuggestionProps): ReactElement => {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <CurrentUserContextProvider>
          <UserOrganizationContextProvider organizationId={organizationid}>
            <InvoiceOverviewReconciliationSuggestionContent
              invoiceId={invoiceid}
              openPaymentModal={onOpenPaymentModal}
            />
          </UserOrganizationContextProvider>
        </CurrentUserContextProvider>
      </ThemeProvider>
    </QueryClientProvider>
  )
}

const InvoiceOverviewReconciliationSuggestionCustomElement = createCustomElement(
  InvoiceOverviewReconciliationSuggestion,
  InvoiceOverviewReconciliationSuggestionWebComponent,
  'element',
)

customElements.get(MODULE_NAME) ||
  customElements.define(MODULE_NAME, InvoiceOverviewReconciliationSuggestionCustomElement)

export default InvoiceOverviewReconciliationSuggestionCustomElement
